import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';

export const StyledDialog = styled(Dialog)`
  & div.MuiDialog-paper {
    width: 30rem;
    max-width: 30rem;
  }
`;
